import { render, staticRenderFns } from "./Vedio.vue?vue&type=template&id=de46cc9c&scoped=true&"
import script from "./Vedio.vue?vue&type=script&lang=js&"
export * from "./Vedio.vue?vue&type=script&lang=js&"
import style0 from "./Vedio.vue?vue&type=style&index=0&id=de46cc9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de46cc9c",
  null
  
)

export default component.exports